import { useEffect, useState } from 'react';
import { CheckBox, Message } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import clsx from 'clsx';
import { TSignupFormDataDE } from 'components/Signup/NewSignupFormDE/NewSignupFormDE.types';

import { TSignupFormData } from 'components/Signup/SignupForm/SignupForm.types';
import { TGetStateResponseRoles } from 'lendingApi/lapiOverrides.types';
import { useFormContext } from 'react-hook-form';
import styles from './GuarantorRoles.module.css';

type TProps = {
  index: number;
};

export const GuarantorRoles = ({ index }: TProps) => {
  const {
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext<TSignupFormData | TSignupFormDataDE>();
  const [roles, setRoles] = useState<TGetStateResponseRoles>(
    getValues(`guarantors.${index}.roles`) || [],
  );

  const hasError = errors.guarantors?.[index]?.roles?.message;

  const handleCheckboxSelection = (value: TGetStateResponseRoles[number]) => {
    if (!roles.includes(value)) {
      setRoles([...roles, value]);
    } else {
      const updatedRoles = roles.filter((item) => {
        return item !== value;
      });
      setRoles(updatedRoles);
    }
  };

  useEffect(() => {
    setValue(`guarantors.${index}.roles`, roles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roles]);

  return (
    <div
      className={clsx(styles.rolesContainer, { [styles.hasError]: hasError })}
    >
      <div className={styles.checkboxesContainer}>
        <CheckBox
          id={`director-${index}`}
          name={`director-${index}`}
          label={t`Director`}
          checked={roles?.includes('director')}
          onChange={() => {
            handleCheckboxSelection('director');
          }}
        />
        <CheckBox
          id={`guarantor-${index}`}
          name={`guarantor-${index}`}
          label={t`Guarantor`}
          checked={roles?.includes('guarantor')}
          onChange={() => {
            handleCheckboxSelection('guarantor');
          }}
        />
        <CheckBox
          id={`shareholder-${index}`}
          name={`shareholder-${index}`}
          label={t`Shareholder`}
          checked={roles?.includes('shareholder')}
          onChange={() => handleCheckboxSelection('shareholder')}
        />
      </div>
      {errors.guarantors?.[index]?.roles?.message && (
        <Message
          className={styles.error}
          message={errors.guarantors?.[index]?.roles?.message || ''}
          type="error"
        />
      )}
    </div>
  );
};
